import React from "react";
import { Badge } from "@/components/ui/badge";
import { Clock } from "lucide-react";

interface MintedStatusBadgeProps {
  isMinted: boolean;
  className?: string;
}

const MintedStatusBadge: React.FC<MintedStatusBadgeProps> = ({ isMinted, className = "" }) => {
  if (isMinted) {
    return (
      <Badge 
        className={`bg-gradient-to-r from-amber-400 via-yellow-300 to-amber-500 text-amber-900 border-amber-600 font-semibold shadow-sm ${className}`}
      >
        <span className="mr-1">▰</span>
        Minted
      </Badge>
    );
  }

  return (
    <Badge 
      variant="outline" 
      className={`border-amber-400 text-amber-600 bg-amber-50 ${className}`}
    >
      <Clock className="h-3 w-3 mr-1" />
      Draft
    </Badge>
  );
};

export default MintedStatusBadge;
